import { LiteTheme } from './LiteTheme'

var theme_ = new LiteTheme();

globalThis.theme_ = theme_


export default theme_;
